import FormFeedback from "../form/form-feedback.js";
import FormLabel from "../form/form-label.js";
import FieldComponent from "./field.js";
const Field = FieldComponent;
Field.Label = FormLabel;
Field.Feedback = FormFeedback;
export default Field;
